var availableColors = {
	client		:	'#5677fc',	// blue
	supplier	:	'#ff9800',	// orange
	prospect	:	'#9e9e9e',	// grey
	staff		:	'#C93455'	// red
};

window.TokenInput = {
	autoAddress: function(field){

		var id				= $(field).attr('id');
		var part			= id.split('_');
		var fieldName		= part[1];
		var tokenName		= 'town' === fieldName  ? 'name' : 'zipcode';
		var prefix			= part[0]+'_';
		var placeholder		= $(field).attr('placeholder');

		var datas = new Object();
		datas[tokenName] = Persistent.get(id,false,false);

		var options = {
			id					: '#'+id ,
			page				: 'geo',
			minChars			: 2,
			tokenLimit			: 1,
			allowCustomEntry	: true,
			action				: 'autocompletion',
			css					: 'token-input-list token-input-one '+$(field).attr('class'),
			placeholderText		: (placeholder == '' || placeholder == undefined ) ? Loc.g('Rechercher') : placeholder,
			tokenValue			: tokenName,
			propertyToSearch	: tokenName,
			url					: "&country="+$("#"+prefix+"countrycode").val()+"&field="+fieldName,
		};

		if(Persistent.get(id)!==''){
			options.prePopulate = [datas];
		}

		options.onAdd = function(item) {
			if(item[fieldName === 'zip' ? 'name' :'zipcode'] !== undefined ) {

				$('#'+prefix+(fieldName === 'zip' ? 'town' :'zip')).tokenInput("add", {id:0 , name:item.name , zipcode:item.zipcode});

				var visible = $('#'+prefix+'state').parent().parent().is(':visible');

				$('body').data('updatingState', true);
				if(item.subname !== undefined && item.subname !== "" && visible) {
					$('#'+prefix+'state').tokenInput("add", {id: item.subident, name: item.subident, formattedName: item.subident+" - "+item.subname});
				}else {
					$('#'+prefix+'state').tokenInput("clear");
				}
				$('body').data('updatingState', false);


			}
			return false;
		};

		options.onDelete = function(item) {
			// town
			$('#'+prefix+(fieldName==='zip' ? 'town' :'zip')).tokenInput("clear");

			// state
			$('#'+prefix+'state').tokenInput('clear');
			$('#'+prefix+'state').val('');

			return false;
		};

		options.beforeSearch = function(settings) {
			settings.url = "/?_f=geo&country="+$("#"+prefix+"countrycode").val()+"&field="+fieldName;
			return false;
		};

		options.resultsFormatter = function(item) {
		 	return '<li >'+item.name+' ('+item.zipcode+')'+'</li>';
		};

		TokenInput.create(options);
	},

	updateAddress: function() {

		Address.changeCountry($('[id*="address_countrycode"]:first'));

		$('*[e_autogeo], *[e_autostate]').each(function(){
			if($(this).val().length > 0){
				Persistent.set($(this).attr('id'), $(this).val(), $(this).parent());
			}
		});

		$('*[e_autogeo], *[e_autostate]').first().tokenInput('clear');


		$('*[e_autogeo], *[e_autostate]').each(function(){
			var id			= $(this).attr('id');
			var fieldValue 	= Persistent.get(id);

			if(fieldValue.length > 0){
				var part			= id.split('_');

				var fieldName		= part[1] === 'zip' ? ['zipcode'] : (part[1] === 'town' ? ['name'] : ['name', 'id', 'formattedName']);
				var datas			= new Object();
				$.each(fieldName, function(i, field){
					datas[field]	= fieldValue;
				});

				TokenInput.update(this ,datas);
			}

		});

	},

	// Allow users
	autoAddresses : function(field, type, more, max, addCallback, delCallback){

		var id		= $(field).attr('id');
		var max			= undefined === max ? 20 : max;
		var addCallback	= undefined === addCallback ? '' : addCallback;
		var delCallback	= undefined === delCallback ? '' : delCallback;
        var placeholder	= $(field).attr('placeholder');

		var options = {
			id					: '#'+id,
			page				: 'address',
			url					: '&type='+type,
			action				: 'autocomplete',
			minChars			: 3,
			tokenLimit			: max,
			allowCustomEntry	: false,
			searchOnFocus		: true,
			hintText			: Loc.g("Nom ou partie de l'adresse"),
			noResultsText		: Loc.g('Aucun résultat'),
			more				: more,
			tokenValue			: 'id',
			prePopulate			: Persistent.get(id,true,false),
            placeholderText		: (placeholder == '' || placeholder == undefined ) ? Loc.g('Rechercher') : placeholder,
			resultsFormatter 	: function(item) {

				var htmlFormater	= "<li style='width:100%' class='formated_auto_item'>";
				htmlFormater		+=	"<div class='auto_item_desc'>";
				htmlFormater		+=		"<span>"+item.name+"</span><br />";
				htmlFormater		+=		"<span style='font-size:10px;color:#B3B3B3;'>"+item.formatted+"</i>";
				htmlFormater		+=	"</div>";
				htmlFormater	    += '</li>';

				return htmlFormater;

			}
		};

		if (addCallback !== ''){
			if (jQuery.isFunction(addCallback)){
				options.onAdd = addCallback;
			} else {
				options.onAdd = function(item){eval(addCallback);};
			}
		}
		if (delCallback !== ''){
			if (typeof delCallback === 'function'){
				options.onDelete = delCallback;
			} else {
				options.onDelete = function(item){eval(delCallback);};
			}
		}

		TokenInput.create(options);
	},

	autoState: function(field){

		var id				= $(field).attr('id');
		var part			= id.split('_');
		var prefix			= part[0]+'_';
		var placeholder		= $(field).attr('placeholder');
		var datas			= Persistent.get(id,true,false);

		var options = {
			id					: '#'+id ,
			page				: 'geo',
			minChars			: 2,
			tokenLimit			: 1,
			allowCustomEntry	: true,
			action				: 'autocompleteState',
			css					: 'token-input-list token-input-one '+$(field).attr('class'),
            placeholderText		: (placeholder == '' || placeholder == undefined ) ? Loc.g('Rechercher') : placeholder,
			prePopulate			: datas,
			searchOnFocus		: true,
			url					: "&country="+$("#"+prefix+"countrycode").val(),
		};

		options.beforeSearch = function(settings) {
			settings.url = "/?_f=geo&country="+$("#"+prefix+"countrycode").val();
			return false;
		};

		options.onDelete = function(item) {
			// town
			if(!$('body').data('updatingState')) {
				$('#'+prefix+'zip').tokenInput("clear");
				$('#'+prefix+'town').tokenInput("clear");
			}
		};

		options.resultsFormatter = function(item) {
			return '<li >'+item.formattedName+'</li>';
		};

		TokenInput.create(options);
	},

	autoContactListing: function(field, type, max, searchOnFocus, more, selCallback, delCallback, placeholder) {

		max				= undefined ===	max ? 20 : max;
		more			= undefined ===	more ? '' : more;
		selCallback		= undefined ===	selCallback ? '' : selCallback;
		delCallback		= undefined ===	delCallback ? '' : delCallback;
		placeholder		= undefined === placeholder ? '' : placeholder;
		searchOnFocus	= searchOnFocus == 'true' || searchOnFocus == true;

		if(placeholder == ''){
			placeholder		= $(field).attr('placeholder');
		}

		var id				= $(field).attr('id');
		var part			= id.split('_');
		var listingPrefix	= part[0];
		var datas			= Persistent.get(id,true,false);

		var startText	= Loc.g("Saisir le nom d'un client");
		var	nrt			= Loc.g('Aucun client correspondant');


		if(type === 'staff'){
			startText = Loc.g("Saisir le nom d'un collaborateur");
			nrt = Loc.g('Aucun collaborateur correspondant');
		}

		if (type === 'prospect'){
			startText = Loc.g("Saisir le nom d'un prospect");
			nrt = Loc.g('Aucun prospect correspondant');
		}

		if (type === 'supplier'){
			startText = Loc.g("Saisir le nom d'un fournisseur");
			nrt = Loc.g('Aucun fournisseur correspondant');
		}

		var options = {
			id					: '#'+id,
			page				: 'contacts',
			url					: '&type='+type,
			action				: 'autocompletion',
			searchOnFocus		: searchOnFocus,
			minChars			: 1,
			tokenLimit			: max,
			allowCustomEntry	: false,
			hintText			: startText,
			noResultsText		: nrt,
			prePopulate			: datas,
			more				: more,
            placeholderText		: (placeholder == '' || placeholder == undefined ) ? Loc.g('Rechercher') : placeholder,
			tips 				: Loc.g("Pour rechercher un contact via son adresse email, veuillez saisir la totalité de l'adresse email dans le champ de recherche"),
		};


		options.resultsFormatter	= function(item) {

			var htmlFormater	= "<li style='display:table;display:table; width:100%; border-left:5px solid " + availableColors[item.relationType] + ";' class='formated_auto_item'>";
			htmlFormater		+=	"<div class='auto_item_pc' style='display:table-cell;width:40px;text-align:center;'>";
			htmlFormater		+=		item.avatar;
			htmlFormater		+=	"</div>";
			htmlFormater		+=	"<div class='auto_item_desc' style='display:table-cell;vertical-align:middle;'>";
			htmlFormater		+=		"<span>"+item.name+"</span><br />";
			htmlFormater		+=		"<span style='font-size:10px;color:#B3B3B3;'>"+item.thirdname+"</span>";
			htmlFormater		+=	"</div>";
			htmlFormater	    += '</li>';

			return htmlFormater;
		};

		options.onAdd = function(item) {
			Listing.update($("#"+listingPrefix+"_filterFormName").val(), true, true);
		};


		if (selCallback !== ''){
			if (typeof selCallback === 'function'){
				options.onAdd = selCallback;
			} else {
				options.onAdd = function(item){eval(selCallback);};
			}
		}

		options.onDelete = function(item) {
			Listing.update($("#"+listingPrefix+"_filterFormName").val(), true, true);
		};

		if (delCallback !== ''){
			if (typeof delCallback === 'function'){
				options.onDelete = delCallback;
			} else {
				options.onDelete = function(item){eval(delCallback);};
			}
		}

		TokenInput.create(options);
	},

	autoPeople: function(field, max, searchOnFocus, more, selCallback, delCallback, custom, searchType){

		custom			= undefined ===custom ? false : custom;
		max				= undefined ===max ? 20 : max;
		more			= undefined ===more ? '' : more;
		selCallback		= undefined ===selCallback ? '' : selCallback;
		delCallback		= undefined ===delCallback ? '' : delCallback;
		searchOnFocus	= searchOnFocus == 'true'  || searchOnFocus == true;
		searchType			= undefined === searchType ? 'autocomplete' : searchType;

		var placeholder		= $(field).attr('placeholder');
		var id				= $(field).attr('id');
		var part			= id.split('_');
		var listingPrefix	= part[0];
		var datas			= Persistent.get(id,true,false);

		var options = {
			id					: '#'+id,
			page				: 'people',
			url					: '&action=autocompletion&search_type=' + searchType,
			action				: 'autocompletion',
			searchOnFocus		: searchOnFocus,
			minChars			: 1,
			tokenLimit			: max,
			allowCustomEntry	: (custom ? true : false),
			hintText			: Loc.g("Saisir le nom d'un contact"),
			noResultsText		: Loc.g('Aucun contact correspondant'),
			prePopulate			: datas,
			more				: more,
            placeholderText		: (placeholder == '' || placeholder == undefined ) ? Loc.g('Rechercher') : placeholder,
		};

		options.resultsFormatter	= function(item) {

			var htmlFormater	= "<li style='width:100%; display:table; border-left:5px solid " + availableColors[item.relationType] + ";' class='formated_auto_item'>";
			htmlFormater		+=	"<div class='auto_item_pc' style='display:table-cell;width:40px;text-align:center;'>";
			htmlFormater		+=	item.avatar
			htmlFormater		+=	"</div>";
			htmlFormater		+=	"<div class='auto_item_desc' style='display:table-cell;vertical-align:middle;'>";
			htmlFormater		+=		"<span>"+item.name+"</span><br />";
			htmlFormater		+=	"</div>";
			htmlFormater	    += '</li>';

			return htmlFormater;
		};

		options.onAdd = function(item) {};
		if (selCallback !== ''){
			if (typeof selCallback === 'function'){
				options.onAdd = selCallback;
			} else {
				options.onAdd = function(item){eval(selCallback);};
			}
		}

		options.onDelete = function(item) {
			Listing.update($("#"+listingPrefix+"_filterFormName").val(), true);
		};
		if (delCallback !== ''){
			if (typeof delCallback === 'function'){
				options.onDelete = delCallback;
			} else {
				options.onDelete = function(item){eval(delCallback);};
			}
		}

		TokenInput.create(options);
	},

	autoStaff: function(field, max, searchOnFocus, more, selCallback, delCallback, custom, withBlocked){

		custom			= undefined ===custom ? false : custom;
		withBlocked		= undefined === withBlocked || 'N' === withBlocked? 'N' : 'Y';
		max				= undefined ===max ? 20 : max;
		more			= undefined ===more ? '' : more;
		selCallback		= undefined ===selCallback ? '' : selCallback;
		delCallback		= undefined ===delCallback ? '' : delCallback;
		searchOnFocus	= searchOnFocus == 'true'  || searchOnFocus == true;

		var placeholder		= $(field).attr('placeholder');
		var id				= $(field).attr('id');
		var part			= id.split('_');
		var listingPrefix	= part[0];
		var datas			= Persistent.get(id,true,false);

		var options = {
			id					: '#'+id,
			page				: 'staff',
			url					: '&action=autocompletion&withBlocked='+withBlocked,
			action				: 'autocompletion',
			searchOnFocus		: searchOnFocus,
			minChars			: 1,
			tokenLimit			: max,
			allowCustomEntry	: (custom ? true : false),
			hintText			: Loc.g("Saisir le nom d'un staff"),
			noResultsText		: Loc.g('Aucun staff correspondant'),
			prePopulate			: datas,
			more				: more,
            placeholderText		: (placeholder == '' || placeholder == undefined ) ? Loc.g('Rechercher') : placeholder,
		};


		options.resultsFormatter	= function(item) {

			var htmlFormater	= "<li style='display:table; width:100%; border-left:5px solid #C93455;' class='formated_auto_item'>";
			htmlFormater		+=	"<div class='auto_item_pc' style='display:table-cell;width:40px;text-align:center;'>";
			htmlFormater		+=		item.avatar
			htmlFormater		+=	"</div>";
			htmlFormater		+=	"<div class='auto_item_desc' style='display:table-cell;vertical-align:middle;'>";
			htmlFormater		+=		"<span>"+item.name+"</span><br />";
			htmlFormater		+=		"<span style='font-size:10px;color:#B3B3B3;'>"+item.email+"</span>";
			htmlFormater		+=	"</div>";
			htmlFormater	    += '</li>';

			return htmlFormater;
		};

		options.onAdd = function(item) {};
		if (selCallback !== ''){
			if (typeof selCallback === 'function'){
				options.onAdd = selCallback;
			} else {
				options.onAdd = function(item){eval(selCallback);};
			}
		}

		options.onDelete = function(item) {
			Listing.update($("#"+listingPrefix+"_filterFormName").val(), true);
		};
		if (delCallback !== ''){
			if (typeof delCallback === 'function'){
				options.onDelete = delCallback;
			} else {
				options.onDelete = function(item){eval(delCallback);};
			}
		}

		TokenInput.create(options);
	},

	autoBarcode: function(field, itemid, declid, whid, inStock, max, callback, serialOrBarcode){

		var id				= $(field).attr('id');
		var max				= undefined === max ? 1 : max;
		var callback		= undefined === callback ? '' : callback;
		var inStock			= undefined === inStock ? "Y" : inStock;
		var serialOrBarcode = undefined === serialOrBarcode ? "serial" : serialOrBarcode;
		var placeholder		= $(field).attr('placeholder');

		var options = {
			id					: '#'+id,
			page				: 'catalogue',
			action				: 'autocompletebc',
			url					: "&itemid="+itemid+"&declid="+declid,
			more				: {whid:whid, inStock:inStock, serialOrBarcode:serialOrBarcode},
			minChars			: 3,
			tokenLimit			: max,
			allowCustomEntry	: false,
			searchOnFocus		: true,
			hintText			: Loc.g("Code barre"),
			noResultsText		: Loc.g('Aucun résultat'),
			tokenValue			: 'id',
			prePopulate			: Persistent.get(id,true,false),
			resultsFormatter 	: function(item) {return '<li >'+item.name+'</li>';},
            placeholderText		: (placeholder == '' || placeholder == undefined ) ? Loc.g('Rechercher') : placeholder,
		};


		if (callback !== ''){
			if (typeof callback === 'function'){
				options.onAdd = callback;
			} else {
				options.onAdd = function(item){eval(callback);};
			}
		}

		TokenInput.create(options);

	},

	autoItem: function(field, type, more, max, callback, delcallback, searchType){

		var id			= $(field).attr('id');
		var max			= undefined === max ? 20 : max;
		var callback	= undefined === callback ? '' : callback;
		var delcallback	= undefined === delcallback ? '' : delcallback;
		var placeholder	= $(field).attr('placeholder');
		searchType	= undefined === searchType ? 'autocomplete' : searchType;

		var options = {
			id					: '#'+id,
			page				: 'catalogue',
			url					: '&type='+type+'&search_type=' + searchType,
			action				: 'autocomplete',
			minChars			: 3,
			tokenLimit			: max,
			allowCustomEntry	: false,
			searchOnFocus		: true,
			hintText			: Loc.g("Référence ou nom"),
			noResultsText		: Loc.g('Aucun résultat'),
			more				: more,
			tokenValue			: 'id',
			prePopulate			: Persistent.get(id,true,false),
            placeholderText		: (placeholder == '' || placeholder == undefined ) ? Loc.g('Rechercher') : placeholder,
			resultsFormatter : function(item) {

				var htmlFormater	= "<li style='width:100%; display:table;' class='formated_auto_item ac-item '>";
				htmlFormater		+=	"<div class='auto_item_pc' style='display:table-cell;width:40px; text-align:center;'>";
				htmlFormater		+=		"<img style='width:25px;height:25px' src='"+item.pic+"'/>";
				htmlFormater		+=	"</div>";
				htmlFormater		+=	"<div class='auto_item_desc' style='display:table-cell;vertical-align:middle;'>";
				htmlFormater		+=		"<span>"+item.name+"</span><br />";
				htmlFormater		+=		"<span style='font-size:10px;' class='gray-60'>"+item.tradename+"</i>";
				htmlFormater		+=	"</div>";
				htmlFormater	    += '</li>';


				return htmlFormater;

			}
		};


		if (callback !== ''){
			if (typeof callback === 'function'){
				options.onAdd = callback;
			} else {
				options.onAdd = function(item){eval(callback);};
			}
		}

		if (delcallback !== ''){
			if (typeof delcallback === 'function'){
				options.onDelete  = delcallback;
			} else {
				options.onDelete  = function(item){eval(delcallback);};
			}
		}

		TokenInput.create(options);

	},

	autoGroup: function(field, type, more){

		var id = $(field).attr('id');
        var placeholder	= $(field).attr('placeholder');

		var options = {
			id					: '#'+id,
			page				: 'sharepoint',
			url					: '&type='+type,
			action				:'autoCompleteGroup',
			minChars			: 3,
			tokenLimit			: 20,
			allowCustomEntry	: false,
			searchOnFocus		: true,
			hintText			: Loc.g("Nom du groupe"),
			more 				: more,
			tokenValue 			: 'id',
			prePopulate			: Persistent.get(id, true, false),
            placeholderText		: (placeholder == '' || placeholder == undefined ) ? Loc.g('Rechercher') : placeholder,
			resultsFormatter : function(item) {
				return '<li >'+item.name+'</li>';
			},
		};

		TokenInput.create(options);

	},

	autoContactGroup: function(field, type, linked, more, max, selCallback, delCallback) {
		var id 		= $(field).attr('id');
		var max 	= (undefined === max) ? 20 : max;
        var placeholder	= $(field).attr('placeholder');
		var options = {
			id				: '#'+id,
			page			 : 'contacts',
			url				 : '&type='+type,
			action			 : 'autocompletionGroup',
			minChars		 : 1,
			tokenLimit		 : max,
			allowCustomEntry : true,
			searchOnFocus	 : (type.indexOf('|') > -1) ? false : true,
			hintText		 : Loc.g("Saisir le nom d'un groupe, d'un contact ou son email"),
			more 			 : more,
			linked 			 : linked,
			tokenValue 		 : 'id',
			propertyToSearch : 'name',
			prePopulate		 : Persistent.get(id, true, false),
            placeholderText	 : (placeholder == undefined ) ? Loc.g('Rechercher') : placeholder,
		};

		options.tokenFormatter = function(item) {
			var htmlFormater = "<li>";
			htmlFormater 	 += "<p";
			if (undefined !== item['email'] && '' != item['email']) {
				htmlFormater 	 += " tips='"+item['email']+"'";
			}
			htmlFormater 	 += "> " + item[this.propertyToSearch] + "</>";
			htmlFormater 	 += "</li>";

			return htmlFormater;
		};

		options.resultsFormatter = function(item) {
			var htmlFormater	= "<li style='display:table; width:100%; border-left:5px solid "+availableColors[item.relationType]+";' class='formated_auto_item'>";
			htmlFormater		+=	"<div class='auto_item_pc' style='display:table-cell;width:40px;text-align:center;'>";
			htmlFormater		+=		item.avatar;
			htmlFormater		+=	"</div>";
			htmlFormater		+=	"<div class='auto_item_desc' style='display:table-cell;vertical-align:middle;'>";
			htmlFormater		+=		"<span>"+item.name+"</span><br />";
			htmlFormater		+=		"<span style='font-size:10px;color:#B3B3B3;'>"+item.email+"</span>";
			htmlFormater		+=	"</div>";
			htmlFormater	    += '</li>';

			return htmlFormater;
		};

		selCallback = (undefined === selCallback) ? '' : selCallback;
		delCallback = (undefined === delCallback) ? '' : delCallback;

		if (selCallback !== '') {
			if (typeof selCallback === 'function') {
				options.onAdd = selCallback;
			} else {
				options.onAdd = function(item){ eval(selCallback); };
			}
		} else {
			options.onAdd = function(item){ Qtip.init(); };
		}

		if (delCallback !== ''){
			if (typeof delCallback === 'function') {
				options.onDelete = delCallback;
			} else {
				options.onDelete = function(item){ eval(delCallback); };
			}
		}

		TokenInput.create(options);
	},

	autoContact: function(field,type, more, max, selCallback, delCallback){

		var id = $(field).attr('id');
		var max = undefined===max ? 20 : max;
        var placeholder	= $(field).attr('placeholder');

		var options = {
			id					: '#'+id,
			page				: 'contacts',
			url					: '&type='+type,
			action				: 'autocompletion',
			minChars			: 1,
			tokenLimit			: max,
			allowCustomEntry	: true,
			searchOnFocus		: true,
			hintText			: Loc.g("Saisir le nom ou l'email d'un contact"),
			more 				: more,
			tokenValue 			: 'id',
			propertyToSearch 	: 'name',
			prePopulate			: Persistent.get(id,true,false),
            placeholderText		: (placeholder == '' || placeholder == undefined ) ? Loc.g('Rechercher') : placeholder,
		};

        options.resultsFormatter = function(item) {

			var htmlFormater	= "<li style='display:table; width:100%; border-left:5px solid " + availableColors[item.relationType] + ";' class='formated_auto_item'>";
			htmlFormater		+=	"<div class='auto_item_pc' style='display:table-cell;width:40px;text-align:center;'>";
			htmlFormater		+=		item.avatar;
			htmlFormater		+=	"</div>";
			htmlFormater		+=	"<div class='auto_item_desc' style='display:table-cell;vertical-align:middle;'>";
			htmlFormater		+=		"<span>"+item.name+"</span><br />";
			htmlFormater		+=		"<span style='font-size:10px;color:#B3B3B3;'>"+item.email+"</span>";
			htmlFormater		+=	"</div>";
			htmlFormater	    += '</li>';

			return htmlFormater;

		};

		selCallback = undefined===selCallback ? '' : selCallback;
		delCallback = undefined===delCallback ? '' : delCallback;

		if (selCallback !== ''){
			if(typeof selCallback === 'function'){
				options.onAdd = selCallback;
			}else{
				options.onAdd = function(item){eval(selCallback);};
			}
		}

		if (delCallback !== ''){
			if(typeof delCallback === 'function'){
				options.onDelete = delCallback;
			}else{
				options.onDelete = function(item){eval(delCallback);};
			}
		}

		TokenInput.create(options);
	},

	autoProspect: function(field,type, more, max, search){

		var id = $(field).attr('id');
		var max = undefined===max ? 20 : max;
        var placeholder	= $(field).attr('placeholder');

		var options = {
			id					:'#'+id,
			page				:'thirds',
			url					: '&type='+type,
			action				: 'autocompletion',
			minChars			: 1,
			tokenLimit			: max,
			allowCustomEntry	: true,
			searchOnFocus		: false,
			hintText			: Loc.g("Saisir le nom ou l'email d'un contact"),
			more 				: more,
			tokenValue 			: 'id',
			prePopulate			: Persistent.get(id,true,false),
            placeholderText		: (placeholder == '' || placeholder == undefined ) ? Loc.g('Rechercher') : placeholder,
		};

		switch(search){
			case 'name' :
				options.action = 'autocompletionName';
				options.propertyToSearch = search;
				options.resultsFormatter = function(item) {
					return '<li >'+item.name+'</li>';
				};
				break;
			case 'email' :
			default:
				options.action = 'autocompletion';
				options.propertyToSearch = search;
				options.resultsFormatter = function(item) {
					return '<li >'+item.email+' ('+item.name+')'+'</li>';
				};
		}

		TokenInput.create(options);

	},

	autoSupport: function (field, selCallback, more, max, searchType){

		var id				= $(field).attr('id');
		var placeholder		= $(field).attr('placeholder');
		var searchonfocus	= undefined === more ? false : true;
		var selCallback		= undefined === selCallback ? '' : selCallback;
		var more			= undefined === more ? '' : more;
		var max				= undefined === max ? 20 : max;
		searchType	= undefined === searchType ? 'autocomplete' : searchType;

		var options = {
			id					: '#'+id,
			page				: 'support_ticket',
			url					: '&search_type='+searchType,
			action				: 'autocompletion',
			minChars			: 1,
			tokenLimit			: max,
			allowCustomEntry	: false,
			searchOnFocus		: searchonfocus,
			hintText			: Loc.g("Saisir le contenu d'un ticket"),
			placeholderText		: (placeholder == '' || placeholder == undefined ) ? Loc.g('Rechercher') : placeholder,
			tokenValue			: 'id',
			propertyToSearch	: 'ident',
			more				: more,
			prePopulate			: Persistent.get(id,true,false),
		};

        options.resultsFormatter	= function(item) {
			if(item.ident === null) {
				item.ident = '';
			}

			var buffer = '';
			buffer += '<li class="autoSupport ac-item">';
			buffer += '		<span class="name">#' + item.internal + ' - ' + (item.ident).substr(0,20) + '</span>';

            buffer += '<table class="ac-table-selectize">';
            buffer += '<thead>';
            buffer += '<tr>';
            buffer += '<th>';
            buffer += '<div class="info gray-60 ellipsis"><span class="info-label label-small fs-2">'+Loc.g('Expéditeur')+'</span></div>';
            buffer += '</th>';
            buffer += '<th>';
            buffer += '<div class="info gray-60 ellipsis"><span class="info-label label-small fs-2">'+Loc.g('Contenu')+'</span></div>';
            buffer += '</th>';
            buffer += '</tr>';
            buffer += '</thead>';
            buffer += '<tbody>';
            buffer += '<tr>';
            buffer += '<td>';
            buffer += '<div class="info ellipsis" style="width: 100px;"><span class="info-value fs-2">' + item.requesterEmail + '</span></div>';
            buffer += '</td>';
            buffer += '<td>';
            buffer += '<div class="info ellipsis" style="width: 120px;"><span class="info-value fs-2">' + item.snippet + '</span></div>';
            buffer += '</td>';
            buffer += '</tr>';
            buffer += '</tbody>';
            buffer += "</table>";

			buffer += '</li>';

			return buffer;
		};

		if (selCallback !== ''){
			if(typeof selCallback === 'function'){
				options.onAdd = selCallback;
			}else{
				options.onAdd = function(item){eval(selCallback);};
			}
		}

		TokenInput.create(options);

	},

	autoSupportTemplate: function(field, selCallback, delCallback, max) {

		var id 			= $(field).attr('id');
		var placeholder	= $(field).attr('placeholder');
		var selCallback = undefined===selCallback ? '' : selCallback;
		var max			= undefined===max ? 100 : max;

		var options = {
			id					: '#'+id,
			page				: 'support_ticket',
			url					: '',
			action				: 'autocompletionTemplate',
			minChars			: 1,
			tokenLimit			: max,
			allowCustomEntry	: false,
			searchOnFocus		: true,
			hintText			: Loc.g("Saisir le nom du template"),
			placeholderText		: (placeholder == '' || placeholder == undefined ) ? Loc.g('Rechercher') : placeholder,
			tokenValue			: 'id',
			propertyToSearch	: 'name',
			prePopulate			: Persistent.get(id,true,false),
		};

        options.resultsFormatter	= function(item) {
			if(item.ident === null) {
				item.ident = '';
			}

			var buffer = '';
			buffer += '<li>';
			buffer += ' ' + item.name;
			buffer += '</li>';

			return buffer;
		};

		if (selCallback !== ''){
			if(typeof selCallback === 'function'){
				options.onAdd = selCallback;
			}else{
				options.onAdd = function(item){eval(selCallback);};
			}
		}


		if (delCallback !== ''){
			if (typeof delCallback === 'function'){
				options.onDelete  = delCallback;
			} else {
				options.onDelete  = function(item){eval(delCallback);};
			}
		}

		TokenInput.create(options);
	},
	autoProjectEntry: function(field, selCallback, delCallback, more, max){

		var id 			= $(field).attr('id');
		var selCallback = undefined===selCallback ? '' : selCallback;
		var delCallback = undefined===delCallback ? '' : delCallback;
		var max			= undefined===max ? 20 : max;
        var placeholder	= $(field).attr('placeholder');

		var options = {
			action 				: 'autocompletionEntries',
			allowCustomEntry	: true,
			prePopulate			: Persistent.get(id,true,false),
			id					: '#'+id,
			tokenLimit			: max,
			minChars			: 1,
			more 				: more,
			page 				: 'project_ajax',
			propertyToSearch 	: 'ident',
			searchOnFocus		: true,
			hintText			: Loc.g("Saisir le contenu d'une entrée"),
			tokenValue			: 'id',
			url 				: '',
            placeholderText		: (placeholder == '' || placeholder == undefined ) ? Loc.g('Rechercher') : placeholder,
		};

        options.resultsFormatter = function(item) {
			if(item.ident === null) {
				item.ident = '';
			}

			var buffer = '';
			buffer += '<li class="autoProject">';
			buffer += '	<div>';
			buffer += '		<span class="name">' + (item.ident).substr(0,100) + '</span>';
			buffer += '	</div>';
			buffer += '	<div>';
			buffer +=	'	<div class="linked">' + Loc.g("Projet") + " : " + item.projectIdent + '</div>';
			buffer +=	'	<div class="linked">' + Loc.g("Liste") + " : " + item.listIdent + '</div>';
			buffer += '	</div>';
			buffer += '</li>';

			return buffer;
		};

		if (selCallback !== ''){
			if(typeof selCallback === 'function'){
				options.onAdd = selCallback;
			}else{
				options.onAdd = function(item){eval(selCallback);};
			}
		}
		if (delCallback !== ''){
			if(typeof delCallback === 'function'){
				options.onDelete = delCallback;
			}else{
				options.onDelete = function(item){eval(delCallback);};
			}
		}

		TokenInput.create(options);
	},

	autoProject: function(field, selCallback, delCallBack, max, more, searchType){

		var id 			= $(field).attr('id');
		var selCallback = undefined===selCallback ? '' : selCallback;
		var max			= undefined===max ? 1 : max;
        var placeholder	= $(field).attr('placeholder');
		searchType	= undefined === searchType ? 'autocomplete' : searchType;

		var options = {
			id					: '#'+id,
			page				: 'project_ajax',
			url					: '&search_type='+searchType,
			action				: 'autocompletion',
			minChars			: 1,
			tokenLimit			: max,
			allowCustomEntry	: false,
			searchOnFocus		: true,
			hintText			: Loc.g("Saisir le contenu d'un projet"),
			tokenValue 			: 'id',
			propertyToSearch 	: 'ident',
			more 				: more,
			prePopulate			: Persistent.get(id,true,false),
            placeholderText		: (placeholder == '' || placeholder == undefined ) ? Loc.g('Rechercher') : placeholder,
		};

        options.resultsFormatter = function(item) {
			if(item.ident === null) {
				item.ident = '';
			}

			var buffer = '';
			buffer += '<li class="autoProject ac-item">';
			buffer += '		<span class="name ml-1 fs-3">' + (item.ident).substr(0,45) + '</span>';
            buffer += '<table class="ac-table-selectize">';
            buffer += '<thead>';
            buffer += '<tr>';
            buffer += '<th>';
            buffer += '<div class="info gray-60 ellipsis"><span class="info-label label-small fs-2">'+Loc.g('Début')+'</span></div>';
            buffer += '</th>';
            buffer += '<th>';
            buffer += '<div class="info gray-60 ellipsis"><span class="info-label label-small fs-2">'+Loc.g('Fin')+'</span></div>';
            buffer += '</th>';
            buffer += '<th>';
            buffer += '<div class="info gray-60 ellipsis"><span class="info-label label-small fs-2">'+Loc.g('Statut')+'</span></div>';
            buffer += '</th>';
            buffer += '</tr>';
            buffer += '</thead>';
            buffer += '<tbody>';
            buffer += '<tr>';
            buffer += '<td>';
            buffer += '<div class="info ellipsis"><span class="info-value fs-2">' + item.formatted_startDate + '</span></div>';
            buffer += '</td>';
            buffer += '<td>';
            buffer += '<div class="info ellipsis"><span class="info-value fs-2">' + item.formatted_endDate + '</span></div>';
            buffer += '</td>';
            buffer += '<td>';
            buffer += '<div class="info ellipsis"><span class="info-value fs-2">' + item.formatted_step + '</span></div>';
            buffer += '</td>';
            buffer += '</tr>';
            buffer += '</tbody>';
            buffer += "</table>";

			// buffer += '	<div class="ac-infos">';
			// buffer += '<div class="info lightgrey ellipsis"><span class="info-label label-small">'+Loc.g('Crée le')+'</span><span class="info-value">' + item.formatted_createdDate + '</span></div>';
			// buffer += '<div class="info lightgrey ellipsis"><span class="info-label label-small">'+Loc.g('Dates')+'</span><span class="info-value">' + item.formatted_startDate + " - " + item.formatted_endDate + '</span></div>';
			// buffer += '<div class="info lightgrey ellipsis"><span class="info-label label-small">'+Loc.g('Statut')+'</span><span class="info-value">' + item.formatted_step + '</span></div>';
            //
			// buffer += '	</div>';
			buffer += '</li>';

			return buffer;
		};

		if (selCallback !== ''){
			if(typeof selCallback === 'function'){
				options.onAdd = selCallback;
			}else{
				options.onAdd = function(item){eval(selCallback);};
			}
		}

		if (delCallBack !== ''){
			if(typeof delCallBack === 'function'){
				options.onDelete = delCallBack;
			}else{
				options.onDelete = function(item){eval(delCallBack);};
			}
		}

		TokenInput.create(options);

	},

	autoProjectList: function(field, selCallback, delCallBack, more){

		var id			= $(field).attr('id');
		var selCallback = undefined===selCallback ? '' : selCallback;
        var placeholder	= $(field).attr('placeholder');

		var options = {
			id					: '#'+id,
			page				: 'project_ajax',
			url					: '',
			action				: 'autocompletionLists',
			minChars			: 1,
			tokenLimit			: 1,
			allowCustomEntry	: false,
			searchOnFocus		: true,
			hintText			: Loc.g("Saisir le nom de la liste"),
			tokenValue 			: 'id',
			propertyToSearch 	: 'ident',
			more 				: more,
			prePopulate			: Persistent.get(id,true,false),
            placeholderText		: (placeholder == '' || placeholder == undefined ) ? Loc.g('Rechercher') : placeholder,
		};

        options.resultsFormatter = function(item) {
			if(item.ident === null) {
				item.ident = '';
			}

			var buffer = '';
			buffer += '<li class="autoProject">';
			buffer += '	<div>';
            // buffer += '		<span class="name">' + (item.ident).substr(0,20) + '</span>';
            buffer += '		<span class="name">' + item.ident + '</span>';
			buffer += '	</div>';
			buffer += '</li>';

			return buffer;
		};

		if (selCallback !== ''){
			if(typeof selCallback === 'function'){
				options.onAdd = selCallback;
			}else{
				options.onAdd = function(item){eval(selCallback);};
			}
		}

		if (delCallBack !== ''){
			if(typeof delCallBack === 'function'){
				options.onDelete = delCallBack;
			}else{
				options.onDelete = function(item){eval(delCallBack);};
			}
		}

		TokenInput.create(options);

	},

	autoProposal: function(field, type, max, more, selCallback, delCallBack, searchOnFocus, searchType){

		var id 			= $(field).attr('id');
		var selCallback = undefined === selCallback ? '' : selCallback;
		var delCallBack = undefined === delCallBack ? '' : delCallBack;
		var max			= undefined === max ? 1 : max;
		searchOnFocus	= searchOnFocus == 'true'  || searchOnFocus == true;
        var placeholder	= $(field).attr('placeholder');
		searchType	= undefined === searchType ? 'autocomplete' : searchType;

		var options = {
			id 					: '#'+id,
			page 				: 'proposal_proposal',
			url 				: '&type='+type+'&search_type=' + searchType,
			action 				: 'autocompletion',
			minChars			: 1,
			tokenLimit			: max,
			allowCustomEntry	: false,
			searchOnFocus		: searchOnFocus,
			hintText			: Loc.g("Saisir un identifiant ou un nom de document"),
			tokenValue			: 'id',
			propertyToSearch	: 'ident',
			more				: more,
			prePopulate			: Persistent.get(id,true,false),
            placeholderText		: (placeholder == '' || placeholder == undefined ) ? Loc.g('Rechercher') : placeholder,
		};

        options.resultsFormatter = function(item) {

			if(item.ident === null) {
				item.ident = '';
			}

			var buffer = '';

			if(item.type == 'proptemplate'){

				item.ident = item.name;

				buffer += '<li class="autoDoc ac-item">';
				buffer += '		<span class="name">' + item.name + '</span>';

                buffer += '<table class="ac-table-selectize">';
                buffer += '<thead>';
                buffer += '<tr>';
                buffer += '<th>';
                buffer += '<div class="info gray-60 ellipsis"><span class="info-label label-small fs-2">'+Loc.g('Contact lié')+'</span></div>';
                buffer += '</th>';
                buffer += '<th>';
                buffer += '<div class="info gray-60 ellipsis"><span class="info-label label-small fs-2">'+Loc.g('Objet lié')+'</span></div>';
                buffer += '</th>';
                buffer += '</tr>';
                buffer += '</thead>';
                buffer += '<tbody>';
                buffer += '<tr>';
                buffer += '<td>';
                buffer += '<div class="info ellipsis" style="width: 100px;"><span class="info-value fs-2">' + item.linked.formatted + '</span></div>';
                buffer += '</td>';
                buffer += '<td>';
                buffer += '<div class="info ellipsis" style="width: 120px;"><span class="info-value fs-2">' + item.related.formatted + '</span></div>';
                buffer += '</td>';
                buffer += '</tr>';
                buffer += '</tbody>';
                buffer += "</table>";
				buffer += '</li>';

			}else{

				buffer += '<li class="autoDoc ac-item">';
				buffer += '		<span class="name">' + item.name + ' n°' + item.ident +'</span>';

                buffer += '<table class="ac-table-selectize">';
                buffer += '<thead>';
                buffer += '<tr>';
                if(item.thirdname !== null) {
					buffer += '<th>';
					buffer += '<div class="info gray-60 ellipsis"><span class="info-label label-small fs-2">'+Loc.g('Contact lié')+'</span></div>';
					buffer += '</th>';
                }
				buffer += '<th>';
				buffer += '<div class="info gray-60 ellipsis"><span class="info-label label-small fs-2">' + Loc.g('Objet lié') + '</span></div>';
				buffer += '</th>';
                buffer += '</tr>';
                buffer += '</thead>';
                buffer += '<tbody>';
                buffer += '<tr>';
                if(item.thirdname !== null) {
                    buffer += '<td>';
                    buffer += '<div class="info ellipsis" style="width: 100px;"><span class="info-value fs-2">' + item.linked.formatted + '</span></div>';
                    buffer += '</td>';
                }
                buffer += '<td>';
                buffer += '<div class="info ellipsis" style="width: 120px;"><span class="info-value fs-2">' + item.related.formatted + '</span></div>';
                buffer += '</td>';
                buffer += '</tr>';
                buffer += '</tbody>';
                buffer += "</table>";
				buffer += '</li>';

			}

			return buffer;
		};

		if (selCallback !== ''){
			if(typeof selCallback === 'function'){
				options.onAdd = selCallback;
			}else{
				options.onAdd = function(item){eval(selCallback);};
			}
		}

		if (delCallBack !== ''){
			if(typeof delCallBack === 'function'){
				options.onDelete = delCallBack;
			}else{
				options.onDelete = function(item){eval(delCallBack);};
			}
		}

		TokenInput.create(options);
	},

	autoOpportunity: function(field, selCallback, more, max, searchOnFocus, searchType) {

		var id			= $(field).attr('id');
		var placeholder	= $(field).attr('placeholder');
		var selCallback = undefined === selCallback ? '' : selCallback;
		var more		= undefined === more ? '' : more;
		var max			= undefined === max ? 20 : max;
		searchOnFocus	= searchOnFocus == 'true'  || searchOnFocus == true;
		searchType	= undefined === searchType ? 'autocomplete' : searchType;

		var options = {
			id					: '#'+id,
			page				: 'prospection_opportunity',
			url					: '&search_type='+searchType,
			action				: 'autocompletion',
			minChars			: 3,
			tokenLimit			: max,
			allowCustomEntry	: false,
			searchOnFocus		: searchOnFocus,
			hintText			: Loc.g("Saisir l'identifiant d'une opportunité"),
			tokenValue 			: 'id',
			propertyToSearch 	: 'ident',
			prePopulate			: Persistent.get(id,true,false),
			more 				: more,
            placeholderText		: (placeholder == '' || placeholder == undefined ) ? Loc.g('Rechercher') : placeholder
		};

		options.resultsFormatter = function(item) {
			var buffer = '';
			buffer += '<li class="autoopportunity ac-item">';

			buffer += '		<span class="name fs-3">' + item.ident + ' — ' + (item.name).substr(0,20) + '</span>';

            buffer += '<table class="ac-table-selectize">';
            buffer += '<thead>';
            buffer += '<tr>';
            buffer += '<th>';
            buffer += '<div class="info gray-60 ellipsis"><span class="info-label label-small fs-2">'+Loc.g('Client')+'</span></div>';
            buffer += '</th>';
            buffer += '<th>';
            buffer += '<div class="info gray-60 ellipsis"><span class="info-label label-small fs-2">' + Loc.g('Montant potentiel')+'</span></div>';
            buffer += '</th>';
            buffer += '</tr>';
            buffer += '</thead>';
            buffer += '<tbody>';
            buffer += '<tr>';
            buffer += '<td>';
            buffer += '<div class="info ellipsis" style="width: 140px;"><span class="info-value fs-2">' + item.linkedName + '</span></div>';
            buffer += '</td>';
            buffer += '<td>';
            buffer += '<div class="info ellipsis"><span class="info-value fs-2">' + item.potential + '</span></div>';
            buffer += '</td>';
            buffer += '</tr>';
            buffer += '</tbody>';
            buffer += "</table>";
			buffer += '</li>';

			return buffer;
		};

		if (selCallback !== ''){
			if(typeof selCallback === 'function'){
				options.onAdd = selCallback;
			}else{
				options.onAdd = function(item){eval(selCallback);};
			}
		}


		TokenInput.create(options);
	},

	autoAttachement: function(field, more, extension, selCallback, delCallback, max, attachmentName){

		var id 			= $(field).attr('id');
		var selCallback = undefined === selCallback ? '' : selCallback;
		var delCallback = undefined === delCallback ? '' : delCallback;
        var placeholder	= $(field).attr('placeholder');
        var max			= undefined === max ? 20 : max;

		var options = {
			id					: '#'+id,
			page				: 'briefcasev2',
			url					: '' ,
			action				: 'autocompletion',
			searchOnFocus		: true,
			minChars			: 1,
			lowerQuery 			: false,
			tokenLimit			: max,
			allowCustomEntry	: false,
			hintText			: Loc.g('Saisir le nom du fichier'),
			noResultsText		: Loc.g('Aucun fichier correspondant'),
			tokenValue 			: 'id',
			more 				: {directories : more, name : attachmentName},
			propertyToSearch 	: 'name',
			prePopulate			: Persistent.get(id,true,false),
            placeholderText		: (placeholder == '' || placeholder == undefined ) ? Loc.g('Rechercher') : placeholder,
		};

		options.resultsFormatter = function(item) {
			var htmlFormater	= "<li style='display:table; width:100%;' class='formated_auto_item'>";
			htmlFormater		+=	"<div class='auto_item_desc' style='display:table-cell;vertical-align:middle;'>";
			htmlFormater		+=		"<span>"+item.name+"</span><br />";
			htmlFormater		+=		"<span style='font-size:10px;color:#B3B3B3;'>"+item.folderName+"</span>";
			htmlFormater		+=	"</div>";
			htmlFormater	    += '</li>';

			return htmlFormater;
        };

        options.tokenFormatter = function (item) {
            var htmlFormater = "<li class=\"flex-level\" style=\"max-width: 90%\">";
            htmlFormater += "<p class=\"ellipsis\"";
            if (undefined !== item['email'] && '' != item['email']) {
                htmlFormater += " tips='" + item['email'] + "'";
            }
            htmlFormater += "> " + item[this.propertyToSearch] + "</>";
            htmlFormater += "</li>";

            return htmlFormater;
        };

		if(extension !== undefined){
			options.more.extension = extension;
		}

		if (selCallback !== ''){
			options.onAdd = function(item){eval(selCallback)};
		}

		if (delCallback !== ''){
			options.onDelete = function(item){eval(delCallback)};
		}

		TokenInput.create(options);

	},

	autoTag : function(field, type){

		var id					= $(field).attr('id');
		var allowCustomEntry	= $(field).attr('addnew');
		var placeholder			= $(field).attr('placeholder');
		if (allowCustomEntry === undefined){
			allowCustomEntry = true;
		}
		if (allowCustomEntry === 'true'){
			allowCustomEntry = true;
		}

		var options = {
			id					: '#'+id,
			page				: 'tags',
			url					: '&type='+type ,
			action				: 'autocompletion',
			searchOnFocus		: false,
			minChars			: 2,
			tokenLimit			: 20,
			allowCustomEntry	: allowCustomEntry,
			hintText			: Loc.g('Saisir un tag'),
			noResultsText		: Loc.g('Aucun tag correspondant'),
			prePopulate			: Persistent.get(id, true, false),
			tokenValue			: 'id',
			propertyToSearch	: 'name',
            placeholderText		: (placeholder == '' || placeholder == undefined ) ? Loc.g('Rechercher') : placeholder,
		};

		if ($(field).attr('autotag_save') === 'true'){
			options.method = 'post';
			options.onAdd = function(newTag){
				TagEngine.addTag(newTag);
			};
			options.onDelete = function(data){
				var idTag = Text.replace(data.id, 'tag_', '');
				if (Number.isInteger(parseInt(idTag))) {
					TagEngine.deleteTag(idTag);
				}
			};

		}

		if($(field).attr('autotag_searchOnFocus') === 'true'){
			options.searchOnFocus = true;
		}

		TokenInput.create(options);
	},

	autoPromo : function(field, item, type, onDocForm) {

		var id			= $(field).attr('id');
		var type		= type ? type : 'catalogue';
		var onDocForm	= onDocForm ? onDocForm : 'N';
        var placeholder			= $(field).attr('placeholder');

		var options = {
			id					: '#'+id,
			page				: 'cataloguepromo',
			url					: '&type='+type+'&docForm='+onDocForm,
			action				: 'autocompletion',
			searchOnFocus		: true,
			minChars			: 1,
			tokenLimit			: 1,
			hintText			:Loc.g('Recherche en cours'),
			noResultsText		: Loc.g('Aucune promotion correspondante'),
			prePopulate			: Persistent.get(id, true, false),
			tokenValue			: 'id',
			propertyToSearch	: 'name',
			allowCustomEntry	: false,
			searchOnFocus		: true,
			method 				: 'post',
            placeholderText		: (placeholder == '' || placeholder == undefined ) ? Loc.g('Rechercher') : placeholder,
		};

		options.onAdd = function(promotion){

			if(type == 'coupon' && onDocForm == 'Y'){

				ItemPromo.checkCouponForDocForm(DocFormv2.subTotal, $("#thirdid").val(), promotion.coupon, DocFormv2.rateCategory, promotion, field);

			} else {

				var enddate = (promotion.neverexpires == 'Y') ? '~' : promotion.formatted_enddate;

				var onPos  = (promotion.useOnPos == 'Y') ? Loc.g('Oui') : Loc.g('Non');
				var onDoc  = (promotion.useOnDoc == 'Y') ? Loc.g('Oui') : Loc.g('Non');

				$('#promotionDetails_existing .promo_name').html(promotion.name);
				$('#promotionDetails_existing .promo_startdate').html(promotion.formatted_startdate);
				$('#promotionDetails_existing .promo_enddate').html(enddate);
				$('#promotionDetails_existing .promo_useOnDoc').html(onDoc);
				$('#promotionDetails_existing .promo_useOnPos').html(onPos);

				if(promotion.useOnPos == 'Y'){
					var tills = [];
					if(promotion.tills !== undefined){
						$(promotion.tills).each(function( index, till ) {
							tills.push(till.name);
						});
					}

					if(tills.length > 0){
						$('#promotionDetails_existing .promo_useOnPos').append(' (' + tills.join(', ') + ')');
					}
				}

				$('.onePromoToAdd .discountunit').val(promotion.discountunit);
				$('.onePromoToAdd .discountamount').val(promotion.formatted_discountAmount);
				$('.onePromoToAdd .discountunit').trigger('change');

			}

		};

		options.onDelete = function(promotion){

			if(type == 'coupon' && onDocForm == 'Y'){

				DocFormv2.setGlobalDiscount(0, 'percent');

				if($(field).attr('e_showdescondoc') == 'Y'){
					DocFormv2.setNote("", true);
				}

				$('input[name="isShippingFreeForPromotion"]').val('N');
				DocFormv2.renableShippingRows();
				DocFormv2.disableGlobalDiscount(false);

			} else {

				$('#promotionDetails_existing .promo_name').html('...');

				$('#promotionDetails_existing .promo_startdate').html('...');
				$('#promotionDetails_existing .promo_enddate').html('...');

				$('#promotionDetails_existing .promo_useOnDoc').html('...');
				$('#promotionDetails_existing .promo_useOnPos').html('...');
				$('#promotionDetails_existing .promo_useOnEcommerce').html('...');

			}

		};

		options.resultsFormatter	= function(promotion) {

			var enddate = (promotion.neverexpires == 'Y') ? '~' : promotion.formatted_enddate;
			var onEcom = (promotion.useOnEcommerce == 'Y') ? Loc.g('Oui') : Loc.g('Non');
			var onPos  = (promotion.useOnPos == 'Y') ? Loc.g('Oui') : Loc.g('Non');
			var onDoc  = (promotion.useOnDoc == 'Y') ? Loc.g('Oui') : Loc.g('Non');

			var htmlFormater	 =  "<li style='display:table; width:100%; border-left:5px solid #5CB85E; min-height:40px;' class='formated_auto_item'>";
			htmlFormater		+=	"<div class='auto_item_desc' style='display:table-cell;vertical-align:middle;'>";
			htmlFormater		+=	"<span>"+promotion.name+"</span><br />";
			htmlFormater		+=	"<span style='font-size:10px;color:#B3B3B3;'>";
			htmlFormater		+=	promotion.formatted_startdate + ' - ' + enddate + "<br>";

			if(promotion.type == 'coupon'){
				htmlFormater		+=	Loc.g('Remise') + ' : ' + promotion.formatted_discountAmount;
				if(promotion.discountunit == 'percent'){
					htmlFormater += ' %';
				}
			} else {

				htmlFormater		+=	Loc.g('Sur les documents') + ' : ' + onDoc + "<br>";
				htmlFormater		+=	Loc.g('Sur les sites web') + ' : ' + onEcom + "<br>";
				htmlFormater		+=	Loc.g('Sur la caisse') + ' : ' + onPos + "<br>";

			}

			htmlFormater		+=	"</span>";
			htmlFormater		+=	"</div>";
			htmlFormater	    +=  '</li>';

			return htmlFormater;
		};

		TokenInput.create(options);
	},

	autoCashtill : function(field){

		var id = $(field).attr('id');
        var placeholder			= $(field).attr('placeholder');

		var options = {
			id					: '#'+id,
			page				: 'pos_cashtills',
			url					: '',
			action				: 'autocompletion',
			searchOnFocus		: true,
			minChars			: 2,
			tokenLimit			: 20,
			hintText			: Loc.g('Recherche en cours'),
			noResultsText		: Loc.g('Aucune caisse correspondante'),
			prePopulate			: Persistent.get(id, true, false),
			tokenValue			: 'id',
			propertyToSearch	: 'name',
			allowCustomEntry	: false,
            placeholderText		: (placeholder == '' || placeholder == undefined ) ? Loc.g('Rechercher') : placeholder,
		};

		if ($(field).attr('autoCashtill_save') === 'true'){
			options.method		= 'post';
			options.onAdd 		= function(newTag){};
			options.onDelete 	= function(data){};
		}

		if($(field).attr('autoCashtill_searchOnFocus') === 'true'){
			options.searchOnFocus = true;
		}

		options.resultsFormatter	= function(cashtill) {

			var htmlFormater	 =  "<li style='display:table; width:100%; border-left:5px solid #ABBECA; min-height:40px;' class='formated_auto_item'>";
			htmlFormater		+=	"<div class='auto_item_desc' style='display:table-cell;vertical-align:middle;'>";
			htmlFormater		+=	"<span>"+cashtill.name+"</span><br />";
			htmlFormater		+=	"</div>";
			htmlFormater	    +=  '</li>';

			return htmlFormater;
		};

		TokenInput.create(options);
	},

	autoTicketGroup : function(field, type, max, searchOnFocus){

		var id = $(field).attr('id');
        var placeholder			= $(field).attr('placeholder');

		var options = {
			id					: '#'+id,
			page				: 'support_ticket',
			url					: '&type='+type ,
			action				: 'groupAutocompletion',
			searchOnFocus		: false,
			minChars			: 2,
			tokenLimit			: max,
			allowCustomEntry	: false,
			hintText			: Loc.g('Saisir le nom du groupe'),
			noResultsText		: Loc.g('Aucun groupe correspondant'),
			prePopulate			: Persistent.get(id, true, false),
			tokenValue 			: 'id',
			propertyToSearch 	: 'name',
            placeholderText		: (placeholder == '' || placeholder == undefined ) ? Loc.g('Rechercher') : placeholder,
			lowerQuery			: false,
		};


		options.resultsFormatter = function(item) {
			var buffer = '';

			buffer += '<li class="autoTicketGroup" style="border-left: 5px solid #CCC" >';

			buffer += '	<div>';
			buffer += '		<span class="name strong" >' + item.name + '</span><br/>';
			buffer += '		<span class="desc" style="font-size:9px;">' + item.description + '</span>';
			buffer += '	</div>';

			buffer += '</li>';

			return buffer;
		};

		if(searchOnFocus === 'true'){
			options.searchOnFocus = true;
		}

		TokenInput.create(options);
	},

	autoDocumentListing: function(field, type, max, searchOnFocus, more, selCallback, delCallback, context){

		var id 			= $(field).attr('id');
		var placeholder	= $(field).attr('placeholder');
		var max 		= undefined === max ? 20 : max;
		var more 		= undefined === more ? '' : more;
		var selCallback = undefined === selCallback ? '' : selCallback;
		var delCallback = undefined === delCallback ? '' : delCallback;
		var context 	= undefined === context ? '' : context;
		var sof			= false;

		var options = {
			id					:'#'+id,
			page				: 'doc',
			url					: '&type='+type+"&context="+context,
			action				: 'autocompletion',
			searchOnFocus		: sof,
			minChars			: 3,
			tokenLimit			: max,
			allowCustomEntry	: false,
			hintText			: Loc.g('Saisir numero du document'),
			noResultsText 		: Loc.g("Aucun document correspondant"),
            placeholderText		: (placeholder == '' || placeholder == undefined ) ? Loc.g('Rechercher') : placeholder,
			prePopulate			: Persistent.get(id,true,false),
			more				: more,
		};

		if(searchOnFocus){
			options.searchOnFocus	= true;
		}

		if (selCallback !== ''){
			if (typeof selCallback === 'function'){
				options.onAdd = selCallback;
			} else {
				options.onAdd = function(item){eval(selCallback);};
			}
		}
		if (delCallback !== ''){
			if (typeof delCallback === 'function'){
				options.onDelete = delCallback;
			} else {
				options.onDelete = function(item){eval(delCallback);};
			}
		}

		options.resultsFormatter = function(item) {
			var buffer = '';

			if(item.doctype == 'model'){
				buffer += '<li class="autoDoc" style="border-left: 5px solid #CCC">';

				buffer += '	<div>';
				buffer += '		<span class="name">' + item.name + '</span>';
				buffer += '	</div>';

				if (item.subject != ""){
					// take only the first line in the doc object
					var subjects = item.subject.split('<br>');
					buffer += '	<div class="linked">'+Loc.g('Objet')+': ' + subjects[0] + '</div>';
				}

				if (context != 'timetracking') {
					buffer += '		<div class="linked">'+Loc.g('Montant')+': ' + item.formatted_totalAmount + '</div>';
				}

				if (item.tagsList != '') {
					buffer += '		<div class="linked">' + Loc.g('Smart-tags') + ': ' + item.tagsList + '</div>';
				}

				buffer += '</li>';
			}else{
				buffer += '<li class="autoDoc" style="border-left: 5px solid '+item.borderColor+'">';

				buffer += '	<div>';
				buffer += '		<span class="name">' + item.name + '</span>';
				buffer += '	</div>';

				if(item.thirdname !== null) {
					buffer += '	<div class="linked">'+Loc.g('Pour')+' <strong>' + item.thirdname + '</strong></div>';
				}

				if (item.subject != ""){
					buffer += '	<div class="linked">'+Loc.g('Objet')+': ' + item.subject + '</div>';
				}

				if (context != 'timetracking'){
					buffer += '		<div class="linked">'+Loc.g('Montant')+': ' + item.formatted_totalAmount + '</div>';
				}

				if (item.tagsList != ''){
					buffer += '		<div class="linked">' + Loc.g('Smart-tags') + ': ' + item.tagsList + '</div>';
				}

				buffer += '</li>';
			}


			return buffer;
		};

		TokenInput.create(options);
	},

	autoPurchasesListing: function(field, type, max, searchOnFocus, more, selCallback, delCallback, context, searchType){

		var id			= $(field).attr('id');
		var placeholder	= $(field).attr('placeholder');

		var max 		= undefined===max ? 20 : max;
		var more 		= undefined===more ? '' : more;
		var selCallback = undefined===selCallback ? '' : selCallback;
		var delCallback = undefined===delCallback ? '' : delCallback;
		var context 	= undefined === context ? '' : context;
		searchType	= undefined === searchType ? 'autocomplete' : searchType;

		var options = {
			id					: '#'+id,
			page				: 'purchases_purchases',
			url					: '&type='+type+"&context="+context+"&search_type="+searchType,
			action				: 'autocompletion',
			searchOnFocus		: false,
			minChars			: 3,
			tokenLimit			: max,
			allowCustomEntry	: false,
			hintText			: Loc.g('Saisir numero du document'),
			noResultsText 		: Loc.g("Aucun document correspondant"),
            placeholderText		: (placeholder == '' || placeholder == undefined ) ? Loc.g('Rechercher') : placeholder,
			prePopulate			: Persistent.get(id,true,false),
			more 				: more,
		};

		if(searchOnFocus){
			options.searchOnFocus = true;
		}

		if (selCallback !== ''){
			if (typeof selCallback === 'function'){
				options.onAdd = selCallback;
			} else {
				options.onAdd = function(item){eval(selCallback);};
			}
		}

		options.onDelete = delCallback;

		options.resultsFormatter = function(item) {
			var buffer = '';

			if(item.doctype == 'model'){
				buffer += '<li class="autoDoc ac-item">';

				buffer += '	<div>';
				buffer += '		<span class="name">' + item.name + '</span>';
				buffer += '	</div>';

                buffer += '<table class="ac-table-selectize">';
                buffer += '<thead>';
                buffer += '<tr>';
                if (item.subject != "") {
                    buffer += '<th>';
                    buffer += '<div class="info gray-60 ellipsis"><span class="info-label label-small fs-2">' + Loc.g('Objet') + '</span></div>';
                    buffer += '</th>';
                }
                buffer += '<th>';
                buffer += '<div class="info gray-60 ellipsis"><span class="info-label label-small fs-2">' + Loc.g('Montant') + '</span></div>';
                buffer += '</th>';
                buffer += '</tr>';
                buffer += '</thead>';
                buffer += '<tbody>';
                buffer += '<tr>';
                if (item.subject != "") {
                    var subjects = item.subject.split('<br>');
                    buffer += '<td>';
                    buffer += '<div class="info ellipsis" style="width: 120px;"><span class="info-value fs-2">' + subjects[0] + '</span></div>';
                    buffer += '</td>';
                }
                buffer += '<td>';
                buffer += '<div class="info ellipsis" style="width: 120px;"><span class="info-value fs-2">' + item.formatted_totalAmount + '</span></div>';
                buffer += '</td>';
                buffer += '</tr>';
                buffer += '</tbody>';
                buffer += "</table>";

				buffer += '</li>';
			}else{
				buffer += '<li class="autoDoc ac-item">';

				buffer += '	<span class="name">' + item.name + '</span>';

                buffer += '<table class="ac-table-selectize">';
                buffer += '<thead>';
                buffer += '<tr>';
                buffer += '<th>';
                buffer += '<div class="info gray-60 ellipsis" style="width: 75px;"><span class="info-label label-small fs-2">' + Loc.g('Fournisseur') + '</span></div>';
                buffer += '</th>';
                if (item.subject != "") {
                    buffer += '<th>';
                    buffer += '<div class="info gray-60 ellipsis" style="width: 80px;"><span class="info-label label-small fs-2">' + Loc.g('Objet') + '</span></div>';
                    buffer += '</th>';
                }
                buffer += '<th>';
                buffer += '<div class="info gray-60 ellipsis"><span class="info-label label-small fs-2">' + Loc.g('Montant') + '</span></div>';
                buffer += '</th>';
                buffer += '</tr>';
                buffer += '</thead>';
                buffer += '<tbody>';
                buffer += '<tr>';
                buffer += '<td>';
                buffer += '<div class="info ellipsis" style="width: 70px;"><span class="info-value fs-2">' + item.thirdname + '</span></div>';
                buffer += '</td>';
                if (item.subject != "") {
                    var subjects = item.subject.split('<br>');
                    buffer += '<td>';
                    buffer += '<div class="info ellipsis" style="width: 80px;"><span class="info-value fs-2">' + subjects[0] + '</span></div>';
                    buffer += '</td>';
                }
                buffer += '<td>';
                buffer += '<div class="info ellipsis" style="width: 70px;"><span class="info-value fs-2">' + item.formatted_totalAmount + '</span></div>';
                buffer += '</td>';
                buffer += '</tr>';
                buffer += '</tbody>';
                buffer += "</table>";
				buffer += '</li>';
			}

			return buffer;
		};

		TokenInput.create(options);
	},

	autoExpensesListing : function(field, max, searchOnFocus) {
		var max				= undefined	===	max				? 20	: max;
		var searchOnFocus	= undefined === searchOnFocus	? true	: searchOnFocus;

		var id			= $(field).attr('id');
		var placeholder	= $(field).attr('placeholder');
		var startText	= Loc.g('Saisir numéro du document');
		var numformat	= NumberFormat.load();

		var options = {
			id					: '#'+id,
			page				: 'expenses_expenses',
			url					: '',
			action				: 'autocompletion',
			searchOnFocus		: searchOnFocus,
			minChars			: 1,
			tokenLimit			: max,
			allowCustomEntry	: false,
			hintText			: startText,
			noResultsText		: Loc.g("Aucun document correspondant"),
			propertyToSearch	: 'ident',
			prePopulate			: Persistent.get(id,true,false),
            placeholderText		: (placeholder == '' || placeholder == undefined ) ? Loc.g('Rechercher') : placeholder,
		};

		options.resultsFormatter = function(item) {
			var buffer	= '<li class="autoExpenses ac-item">';
			buffer	   += '	<div class="ident">' + item.ident + '</div>';
			buffer	   += ' <div class="amount">' + NumberFormat.formatToDisplayWithCurrency(item.amount, numformat) + '</div>';
			buffer	   += '	<br/>';
			buffer	   += ' <div class="staff">' + item.staff + '</div>';
			buffer	   += ' <div class="date">' + item.date + '</div>';
			buffer	   += '</li>';

			return buffer;
		};

		TokenInput.create(options);
	},

	update: function(obj,datas){
		$(obj).tokenInput("add", datas);
	},

	create: function(options){

		// DEFAULT OPTIONS
		var opts = {
			preventDuplicates	: true,
			hintText 			: Loc.g('Veuillez saisir quelques caractères'),
			noResultsText		: Loc.g('Aucun résultat'),
			searchingText		: Loc.g('Recherche en cours...'),
			queryParam 			: 'value',
			jsonContainer 		: 'root',
			classes 			: { tokenList : options.css }
		};

		for(var name in options){
			var value	= options[name];
			opts[name]	= value;
		}

		var tokenInput		= $(options.id).tokenInput('/?_f='+options.page+''+options.url, opts);
		var tokenInputField	= tokenInput.prev('.token-input-list');

		// TIPS
		if($(options.id).attr('tips') !== undefined && $(options.id).attr('tips').length > 0) {
			tokenInputField.attr('tips', $(options.id).attr('tips'));
		} else if(options.tips !== undefined) {
			tokenInputField.attr('tips', options.tips);
		}

		// TIPS INIT
		if(tokenInputField.attr('tips') !== undefined && tokenInputField.attr('tips').length > 0){
			// POSITION TIPS
			if($(options.id).attr('positiontips') !== undefined && $(options.id).attr('positiontips').length > 0){
				tokenInputField.attr('positiontips', $(options.id).attr('positiontips'));
			} else if (options.positiontips !== undefined) {
				tokenInputField.attr('positiontips', options.positiontips);
			}

			Qtip.init();
		}

	},

	autRental: function(field, type, max, more, selCallback, delCallBack){

		var selCallback = undefined === selCallback ? '' : selCallback;
		var delCallBack = undefined === delCallBack ? '' : delCallBack;
		var max			= undefined === max ? 1 : max;

		var id = $(field).attr('id');
		var placeholder = $(field).attr('placeholder');

		var options = {
			id					: '#'+id,
			page				: 'rent_book',
			url					: '&type='+type,
			action				: 'autocompletion',
			minChars			: 1,
			tokenLimit			: max,
			allowCustomEntry	: false,
			searchOnFocus		: true,
			hintText			: Loc.g("Saisir un identifiant ou un nom de document"),
			tokenValue			: 'id',
			propertyToSearch	: 'ident',
			more				: more,
			prePopulate			: Persistent.get(id,true,false),
            placeholderText		: (placeholder == '' || placeholder == undefined ) ? Loc.g('Rechercher') : placeholder,
		};

        options.resultsFormatter = function(item) {

			item.ident = item.name;

			var buffer = '';
			buffer += '<li class="autoDoc ac-item" style="border-left: 5px solid #'+(item.type == 'rent' ? 'A4FC91' : 'D3E6FF')+'">';
			buffer += '	<div>';
			buffer += '		<span class="name">' + item.name + '</span>';
			buffer += '	</div>';

            buffer += '<table class="ac-table-selectize">';
            buffer += '<thead>';
            buffer += '<tr>';
			buffer += '<th>';
			buffer += '<div class="info gray-60 ellipsis"><span class="info-label label-small fs-2">' + Loc.g('Client') + '</span></div>';
			buffer += '</th>';
            buffer += '<th>';
            buffer += '<div class="info gray-60 ellipsis"><span class="info-label label-small fs-2">' + Loc.g('Produits') + '</span></div>';
            buffer += '</th>';
            buffer += '</tr>';
            buffer += '</thead>';
            buffer += '<tbody>';
            buffer += '<tr>';
			buffer += '<td>';
			buffer += '<div class="info ellipsis" style="width: 120px;"><span class="info-value fs-2">' + item.thirdname + '</span></div>';
			buffer += '</td>';
            buffer += '<td>';
            buffer += '<div class="info ellipsis" style="width: 120px;"><span class="info-value fs-2">' + item.itemName + '</span></div>';
            buffer += '</td>';
            buffer += '</tr>';
            buffer += '</tbody>';
            buffer += "</table>";
			buffer += '</li>';


			return buffer;
		};

		if (selCallback !== ''){
			if(typeof selCallback === 'function'){
				options.onAdd = selCallback;
			}else{
				options.onAdd = function(item){eval(selCallback);};
			}
		}

		if (delCallBack !== ''){
			if(typeof delCallBack === 'function'){
				options.onDelete = delCallBack;
			}else{
				options.onDelete = function(item){eval(delCallBack);};
			}
		}

		TokenInput.create(options);
	},

	autoCampaign: function(field, type, max, more, selCallback, delCallBack, provider){

		var selCallback = undefined === selCallback ? '' : selCallback;
		var delCallBack = undefined === delCallBack ? '' : delCallBack;
		var max = undefined === max ? 1 : max;
		var provider = undefined === provider ? [] : JSON.parse(provider);

		var id = $(field).attr('id');
		var placeholder = $(field).attr('placeholder');
		var url = '&type=' + type;

		provider.forEach(item => {
			url += '&provider[]=' + item;
		});

		var options = {
			id					: '#'+id,
			page				: 'massmailing_campaigns',
			url					: url,
			action				: 'autocompletion',
			minChars			: 1,
			tokenLimit			: max,
			allowCustomEntry	: false,
			searchOnFocus		: true,
			hintText			: Loc.g("Saisir un nom de campagne"),
			tokenValue			: 'id',
			propertyToSearch	: 'name',
			more				: more,
			prePopulate			: $(field).data('populate') ? $(field).data('populate') : Persistent.get(id,true,false),
            placeholderText		: (placeholder == '' || placeholder == undefined ) ? Loc.g('Rechercher') : placeholder,
		};

        options.resultsFormatter = function(item) {

			if(item.ident === null) {
				item.ident = '';
			}

			var buffer = '';


			item.ident = item.name;

			buffer += '<li class="autoDoc ac-item" style="border-left: 5px solid '+item.color+'">';
			buffer += '	<div>';
			buffer += '		<span class="name">' + (item.type == 'email' ? '<i class="fa fa-gray fa-envelope-o"></i>' : '<i class="fa fa-mobile fa-15"></i>') + ' ' + item.name + '</span>';
			buffer += '	</div>';

            buffer += '<table class="ac-table-selectize">';
            buffer += '<thead>';
            buffer += '<tr>';
			buffer += '<th>';
			buffer += '<div class="info gray-60 ellipsis"><span class="info-label label-small fs-2">' + Loc.g('Nb destinataires') + '</span></div>';
			buffer += '</th>';
            buffer += '<th>';
            buffer += '<div class="info gray-60 ellipsis"><span class="info-label label-small fs-2">' + Loc.g('Statut') + '</span></div>';
            buffer += '</th>';
            buffer += '</tr>';
            buffer += '</thead>';
            buffer += '<tbody>';
            buffer += '<tr>';
			buffer += '<td>';
			buffer += '<div class="info ellipsis" style="width: 120px;"><span class="info-value fs-2">' + item.nbReciptiens + '</span></div>';
			buffer += '</td>';
            buffer += '<td>';
            buffer += '<div class="info ellipsis" style="width: 120px;"><span class="info-value fs-2">' + item.status + '</span></div>';
            buffer += '</td>';
            buffer += '</tr>';
            buffer += '</tbody>';
            buffer += "</table>";
			buffer += '</li>';

			return buffer;
		};

		if (selCallback !== '') {
			if(typeof selCallback === 'function'){
				options.onAdd = selCallback;
			}else{
				options.onAdd = function(item){eval(selCallback);};
			}
		}

		if (delCallBack !== ''){
			if(typeof delCallBack === 'function'){
				options.onDelete = delCallBack;
			}else{
				options.onDelete = function(item){eval(delCallBack);};
			}
		}

		TokenInput.create(options);
	},

    autoBankTransaction: function(field, currencyId) {

        currencyId		= undefined ===	currencyId ? false : currencyId;

        var id				= $(field).attr('id');
        var placeholder		= $(field).attr('placeholder');
        var datas			= Persistent.get(id,true,false);

        var startText	= Loc.g("Saisir le libellé d'une transaction");
        var	nrt			= Loc.g('Aucune transaction correspondante');

		var options = {
			id					: '#'+id,
			page				: 'bankreconciliation_transactions',
			url					: '&currencyId='+currencyId,
			action				: 'autocompletion',
			searchOnFocus		: true,
			minChars			: 3,
			tokenLimit			: 1,
			allowCustomEntry	: false,
			hintText			: startText,
			noResultsText		: nrt,
			prePopulate			: datas,
			placeholderText		: (placeholder == '' || placeholder == undefined ) ? Loc.g('Rechercher') : placeholder,
			lowerQuery			: false,
		};

        options.resultsFormatter	= function(item) {

            var htmlFormater	= "<li style='display:table;display:table; width:100%; class='formated_auto_item' title=\""+item.description+"\">";
            htmlFormater		+=	"<div class='auto_item_desc' style='display:table-cell;vertical-align:middle;'>";
            htmlFormater		+=		"<span>"+item.shortDescription+"</span>";

            if(item.paymentType == 'debit'){
                htmlFormater		+=		"<span style='font-size:12px; color:#F67D8C; float:right;'> - "+item.amount+"</span><br />";
			} else {
                htmlFormater		+=		"<span style='font-size:12px; float:right;'> "+item.amount+"</span><br />";
			}

            htmlFormater		+=		"<span style='font-size:10px;color:#B3B3B3;'>"+item.date+"<br /></span>";
            htmlFormater		+=		"<span style='font-size:10px;color:#B3B3B3;'>"+item.bankAccountName+"</span>";
            htmlFormater		+=	"</div>";
            htmlFormater	    += '</li>';

            return htmlFormater;
        };

        options.onAdd = function(item) {
            $(field).next('input').val(item.id);
        };

        options.onDelete = function(item) {
            $(field).next('input').val('');
        };

        TokenInput.create(options);
    },

	initDocs: function(){


		$(':input[ac-type=doc]').each(function(){
			var $elmt		= $(this);
			var maxItems	= $elmt.attr('ac-maxitems');
			var filter		= $elmt.attr('ac-filter');
			var placeholder	= $elmt.attr('placeholder');

			var options = {
				id					: '#'+$elmt.attr('id'),
				page				: 'docs',
				url					: '&filters='+filter,
				action				: 'search',
				minChars			: 1,
				tokenLimit			: maxItems,
				allowCustomEntry	: false,
				searchOnFocus		: false,
				hintText			: Loc.g("Saisissez un identifiant, objet de document"),
				tokenValue			: 'id',
				propertyToSearch	: 'ident',
				prePopulate			: $elmt.data('populate'),
				placeholderText		: (placeholder == '' || placeholder == undefined ) ? Loc.g('Rechercher') : placeholder,
				jsonContainer 		: 'results',
				queryParam			: 'q',

			};


			options.resultsFormatter = function(item) {

				var htmlFormater	= '<li class="autoDoc px-1 ac-item">';
				htmlFormater		+= '<span class="name">' + item.ident + '</span>';

                htmlFormater += '<table class="ac-table-selectize">';
                htmlFormater += '<thead>';
                htmlFormater += '<tr>';
                if(item.thirdname !== null) {
                    htmlFormater += '<th>';
                    htmlFormater += '<div class="info gray-60 ellipsis"><span class="info-label label-small fs-2">' + Loc.g('Client') + '</span></div>';
                    htmlFormater += '</th>';
                }
                if(item.subject != '') {
                    htmlFormater += '<th>';
                    htmlFormater += '<div class="info gray-60 ellipsis"><span class="info-label label-small fs-2">' + Loc.g('Objet') + '</span></div>';
                    htmlFormater += '</th>';
                }
                htmlFormater += '<th>';
                htmlFormater += '<div class="info gray-60 ellipsis"><span class="info-label label-small fs-2">' + Loc.g('Montant') + '</span></div>';
                htmlFormater += '</th>';
                htmlFormater += '</tr>';
                htmlFormater += '</thead>';
                htmlFormater += '<tbody>';
                htmlFormater += '<tr>';
                if (item.thirdname !== null) {
                    htmlFormater += '<td>';
                    htmlFormater += '<div class="info ellipsis" style="width: 120px;"><span class="info-value fs-2">' + item.thirdname + '</span></div>';
                    htmlFormater += '</td>';
                }
                if (item.subject != "") {
                    htmlFormater += '<td>';
                    htmlFormater += '<div class="info ellipsis" style="width: 120px;"><span class="info-value fs-2">' + item.subject + '</span></div>';
                    htmlFormater += '</td>';
                }
                htmlFormater += '<td>';
                htmlFormater += '<div class="info ellipsis" style="width: 120px;"><span class="info-value fs-2">' + item.formatted_totalAmount + '</span></div>';
                htmlFormater += '</td>';
                htmlFormater += '</tr>';
                htmlFormater += '</tbody>';
                htmlFormater += "</table>";
				htmlFormater += '</li>';

				return htmlFormater;
			};

			TokenInput.create(options);
		});


	},

};
